import { Column, ColumnConfig } from './column';
import { ColumnType } from './column-type.enum';

export const BUTTON_COLUMN_STYLE = 'cell--button';

interface ButtonColumnConfig<T> extends ColumnConfig {
  /** Any classes that should apply to the buttons. The `btn` class is applied automatically. */
  buttonClasses?: string[];

  /** A callback that determines if the button should be disabled. */
  disabled?: (row: T) => boolean;
}

export class ButtonColumn<T> extends Column<T> {
  public title = '';
  public columnType = ColumnType.Button;
  public config: ButtonColumnConfig<T> = {
    cellClasses: [],
    buttonClasses: [],
  };

  constructor(
    public readonly label: string,
    protected readonly onClick: (row: T) => any,
    readonly buttonConfig?: ButtonColumnConfig<T>,
  ) {
    super();
    this.applyConfig(buttonConfig);
    this.config.cellClasses.push(BUTTON_COLUMN_STYLE);
  }

  public toString(): string {
    return `[ButtonColumn (label: ${this.label})]`;
  }

  public get buttonClasses(): string {
    const styles = this.config.buttonClasses ?? [];
    return styles.join(' ');
  }

  public click(event: Event, row: T): void {
    event.stopPropagation();
    this.onClick(row);
  }

  public isDisabled(row: T): boolean {
    if (this.config.disabled) {
      return this.config.disabled(row);
    }
    return false;
  }
}
